import React from "react";

import connectToStores from "alt-utils/lib/connectToStores";
import PassBucketActions from "../actions/PassBucketActions";
import PassBucketStore from "../stores/PassBucketStore";

import WorkingIndicator from "./partials/working-indicator.jsx";

class NewPassBucket extends React.Component {
  constructor(props) {
    super(props);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  static getStores() {
    return [PassBucketStore];
  }

  static getPropsFromStores() {
    return {
      newPassBucketId: PassBucketStore.getState().newPassBucketId
    };
  }

  componentWillMount() {
    if (this.props.location.query.duplicate) {
      return;
    }
    
    PassBucketActions.create({
      name: this.props.location.pathname.includes('membership') ? "Unnamed Membership" : "Unnamed Pass Bucket",
      event_bucket: this.props.params.eventBucketId,
      is_membership: this.props.location.pathname.includes('membership'),
      recurrence_enabled: this.props.location.pathname.includes('membership'),
      recurrence_interval: "year",
      recurrence_count: 1
    });
  }

  componentWillReceiveProps(props) {
    if (props.newPassBucketId) {
      this.context.router.replace(
        `/event_buckets/${props.params.eventBucketId}/${this.props.location.pathname.includes('membership') ? "memberships" : "pass_buckets"}/${props.newPassBucketId}/edit`
      );
    }
  }

  render() {
    return <WorkingIndicator fullPage={true} />;
  }
}

export default connectToStores(NewPassBucket);



// WEBPACK FOOTER //
// ./src/app/components/new-pass-bucket.jsx